import createReducer from '../../../store/createReducer';
import {
    UPDATE_FIELD_VALUE_FF_WS,
    UPDATE_FORM_STATUS_FF_WS,
    SUBMIT_IN_PROGRESS_FF_WS,
    SUBMIT_SUCCESS_FF_WS,
    SUBMIT_ERROR_FF_WS,
    RESET_FORM_FF_WS
} from '../actions/feedbackFormWsActions';

function updateFormStatus(state, action) {
    return {
        ...state,
        [action.payload.fieldName]: action.payload.value
    };
}

function submitInProgress(state) {
    return {
        ...state,
        formSubmitInProgress: true
    };
}

function submitSuccess(state) {
    return {
        ...state,
        formSubmitInProgress: false,
        formSubmitted: true,
        formFailed: false
    };
}

function submitError(state, action) {
    return {
        ...state,
        formSubmitInProgress: false,
        formFailed: true,
        message: action.payload.msg
    };
}

function updateFieldValue(state, action) {
    return {
        ...state,
        fields: {
            ...state.fields,
            [action.payload.name]: {
                ...state.fields[action.payload.name],
                touched: true,
                value: action.payload.value
            }
        }
    };
}

export const initialState = {
    fields: {
        email: {
            value: '',
            required: false
        },
        userName: {
            value: '',
            required: false
        },
        workshopID: {
            value: '',
            required: true
        },
        overall: {
            value: '',
            required: true
        },
        overallComment: {
            value: '',
            required: false
        },
        handsOnContent: {
            value: '',
            required: true
        },
        handsOnContentComment: {
            value: '',
            required: false
        },
        instructor: {
            value: '',
            required: true
        },
        instructorComment: {
            value: '',
            required: false
        },
        otherComments: {
            value: '',
            required: false
        }
    },
    formFailed: false,
    formSubmitted: false,
    formSubmitInProgress: false,
    message: ''
};

function resetForm() {
    return initialState;
}

export default createReducer(initialState, {
    [UPDATE_FIELD_VALUE_FF_WS]: updateFieldValue,
    [UPDATE_FORM_STATUS_FF_WS]: updateFormStatus,
    [SUBMIT_IN_PROGRESS_FF_WS]: submitInProgress,
    [SUBMIT_SUCCESS_FF_WS]: submitSuccess,
    [SUBMIT_ERROR_FF_WS]: submitError,
    [RESET_FORM_FF_WS]: resetForm
});
